var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('nav-menu'),_c('v-main',[_c('v-container',{staticClass:"spacing-playground pa-7",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }